import { Routes } from '@angular/router';
import { AuthGuard } from './core/services/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(c => c.DashboardComponent)
  },
  {
    path: 'courts',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/courts/courts-list/courts-list.component').then(c => c.CourtsListComponent)
  },
  {
    path: 'courts/add',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/courts/court-form/court-form.component').then(c => c.CourtFormComponent)
  },
  {
    path: 'courts/edit/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/courts/court-form/court-form.component').then(c => c.CourtFormComponent)
  },
  {
    path: 'time-rules',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/time-rules/time-rules.component').then(c => c.TimeRulesComponent)
  },
  {
    path: 'reservations',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/reservations/reservations-list/reservations-list.component').then(c => c.ReservationsListComponent)
  },
  {
    path: 'calendar',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/reservations/reservation-calendar/reservation-calendar.component').then(c => c.ReservationCalendarComponent)
  },
  {
    path: 'members',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/members/members-list/members-list.component').then(c => c.MembersListComponent)
  },
  {
    path: 'pricing',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/pricing/pricing-list/pricing-list.component').then(c => c.PricingListComponent)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/reports/reports-dashboard/reports-dashboard.component').then(c => c.ReportsDashboardComponent)
  },
  {
    path: 'competitions',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/competitions/competitions.component').then(c => c.CompetitionsComponent)
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/settings/settings.component').then(c => c.SettingsComponent)
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: '**',
    loadComponent: () =>
      import('./core/components/not-found/not-found.component').then(c => c.NotFoundComponent)
  }
];